export default "__VITE_PUBLIC_ASSET__4eac6b6f__"